// helpers.ts — Pure utility functions for PWD212 form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Derive the status badge for a record (BR-003) */
export const getStatusBadge = (record: {
  fd130_80?: string;
  fd130_26?: string;
} | null): { text: string; cls: string } | null => {
  if (!record) return null;
  const s80 = (record.fd130_80 || '').trim();
  const s26 = (record.fd130_26 || '').trim();
  if (s26 === 'P') return { text: '已結案', cls: 'badge-default' };
  if (s80 === 'P') return { text: '已核准', cls: 'badge-success' };
  if (s80 === '2') return { text: '部長已審核', cls: 'badge-warning' };
  if (s80 === '3') return { text: '處長已審核', cls: 'badge-warning' };
  if (s80 === '4') return { text: '課長已審核', cls: 'badge-warning' };
  if (s80 === '5') return { text: '組長已審核', cls: 'badge-warning' };
  return null;
};

/** Check if record is locked for editing (BR-003) */
export const isLockedForEdit = (record: {
  fd130_80?: string;
  fd130_26?: string;
} | null): boolean => {
  if (!record) return false;
  const s80 = (record.fd130_80 || '').trim();
  const s26 = (record.fd130_26 || '').trim();
  return s80 !== 'N' && s80 !== '' || s26 === 'P';
};

const ALWAYS_READONLY = new Set([
  'fd130_01', 'fd130_33', 'fd130_42', 'fd130_43', 'fd130_44', 'fd130_34', 'fd130_46',
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, _mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  return false;
};

/** Approval status label map (BR-003) */
export const APPROVAL_STATUS: Record<string, string> = {
  N: '未核准',
  P: '已核准',
  '2': '部長已審核',
  '3': '處長已審核',
  '4': '課長已審核',
  '5': '組長已審核',
};

/** Processing category labels */
export const PROCESSING_CATEGORY: Record<number, string> = {
  1: '染色廠',
  2: '定型廠',
  3: '複合廠',
};

/** Pricing method labels */
export const PRICING_METHOD: Record<number, string> = {
  1: '計量',
  2: '計缸',
};

/** Material category labels */
export const MATERIAL_CATEGORY: Record<number, string> = {
  1: '原料',
  2: '半成品',
  3: '成品',
};
